import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { ClubBadge as d } from "../../../assets/svgs/ClubBadge.js";
import { ProductCardPromotionFlag as m } from "../ProductCardPromotionFlag/index.js";
import { ProductCardBadgeClub as u } from "../ProductCardBadge/ProductCardBadgeClube.js";
const x = ({
  isProductClubAndClient: a,
  variant: e,
  hasPlusFriendBadge: l,
  image: t,
  promotion: o
}) => /* @__PURE__ */ c("div", { className: "product-card-image-container", children: [
  a && /* @__PURE__ */ r(
    "div",
    {
      className: `product-club-badge ${e === "horizontal" && "horizontal"}`,
      children: l ? /* @__PURE__ */ r(d, {}) : /* @__PURE__ */ r(u, { text: "Clube" })
    }
  ),
  /* @__PURE__ */ r("img", { className: "image", src: t.url, alt: t.alternateName }),
  o && e === "vertical" && /* @__PURE__ */ r(
    m,
    {
      variant: e,
      productSectionBadge: {
        text: o.flagText,
        color: {
          textColor: o.textColor,
          backGroundColor: o.colorCode
        }
      }
    }
  )
] });
export {
  x as ProductCardImage
};
